import maatPro from '~/common/maat';

export const retainModalMaatEvent = (params: any) => {
  maatPro.$click('hera_landing_retain_modal_event', params);
};

// 加好友弹框事件
export const addContactModalMaatEvent = (params: any) => {
  maatPro.$click('hera_landing_add_contact_modal_event', params);
};

export const pageIndicatorMaatEvent = (pageValue: string, params: Record<string, string | number | boolean>) => {
  maatPro.$action('hera_page_indicator_event', params, pageValue);
};

/*
 * sd1表单页面埋点
 * @param pageValue 页面事件属性 或者名称
 * @param params 参数
 * @returns void
 * */
export const sdPageFormMaatEvent = (pageValue: string, params: Record<string, string | number | boolean>) => {
  maatPro.$click(
    'hera_landing_sd_page_form_event',
    {
      ...params,
      requirement_name: 'sd1表单页面',
    },
    pageValue
  );
};

/*
 * 互动类型表单页面埋点
 * @param pageValue 页面事件属性 或者名称
 * @param params 参数
 * @returns void
 * */
export const lqPageFormMaatEvent = (pageValue: string, params: Record<string, string | number | boolean>) => {
  maatPro.$click(
    'hera_landing_lq_page_form_event',
    {
      ...params,
      requirement_name: '互动类型表单页面',
    },
    pageValue
  );
};
